<template>
    <div>
        <v-card v-if="gitMenuMode == 'push'" :disabled="!isListSettingDone" style="width: 666px;">
            <v-toolbar
                flat
                :color="isOnPrem ? '#292b60':'#0d1117'"
                dark
            >
                <v-toolbar-title style="width: 40%;"><v-icon>mdi-git</v-icon>
                    <span v-if="isOnPrem">&nbsp;Commit to GitLab</span>
                    <span v-else>&nbsp;Commit to GitHub</span>
                </v-toolbar-title>
                <div v-if="!isGitLogin && (!gitUserName || !gitToken)" style="width: 65%; text-align: right;">
                    <v-btn @click="gitMenuMode = 'settings'">
                        <v-icon>mdi-account-circle</v-icon>
                        <div style="font-size: 12px;">Sign in or enter your account information</div>
                    </v-btn>
                    <v-icon style="margin-top: -35px; margin-right: -15px;" color="white" @click="closeMenu()">mdi-close</v-icon>
                </div>

                <div v-else style="width: 60%; text-align: right;">
                    <v-badge
                        :value="gitAvatarHover"
                        color="grey"
                        icon="mdi-pencil"
                        right
                        bottom
                        overlap
                        transition="slide-x-transition"
                    >
                        <v-hover v-model="gitAvatarHover">
                            <v-avatar
                                v-if="isGitLogin"
                                @click="gitMenuMode = 'settings'"
                                style="cursor: pointer;"
                                class="ma-0">
                                <img
                                    :src=gitPicture
                                >
                            </v-avatar>
                            <v-icon 
                                v-else
                                x-large
                                @click="gitMenuMode = 'settings'"
                                style="cursor: pointer;"
                            >
                                mdi-account-circle
                            </v-icon>
                        </v-hover>
                    </v-badge>
                    <v-icon style="margin-top: -35px; margin-right: -15px;" color="white" @click="closeMenu()">mdi-close</v-icon>
                </div>
            </v-toolbar>
            <v-tabs 
                :key="gitTabKey"
                v-model="gitTab"
                vertical
                dark
            >
                <v-tab
                    v-for="item in gitTabItems"
                    :key="item.tab"
                    style="justify-content: left;"
                >
                    <v-icon left>
                        mdi-numeric-{{ item.index }}-circle-outline
                    </v-icon>
                    {{ item.tab }}
                </v-tab>
                <v-tab-item
                    v-for="item in gitTabItems"
                    :key="item.tab"
                >
                    <v-card flat>
                        <div style="margin: 10px;">
                        <!-- <v-divider v-if="!isGitLogin && (!gitOrgName || !gitToken)" /> -->
                                <v-radio-group
                                    v-if="item.tabKey == 'setFirstRepo'"
                                    v-model="gitRadios"
                                    mandatory
                                >
                                    <v-row no-gutters v-if="gitRefRepoUrl">
                                        <v-col cols="3" style="margin-top: 7px;">
                                            <v-radio
                                                label="Fork from "
                                                value="fork"
                                            ></v-radio>
                                        </v-col>
                                        <v-col cols="9">
                                            <v-text-field
                                                readonly
                                                dense
                                                v-model="gitRefRepoUrl"
                                            >
                                                <template v-if="(!isFirstCommit || isDuplicate)" v-slot:append-outer>
                                                    <v-tooltip left>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon v-on="on" @click="openGitRepo()">
                                                                mdi-open-in-new
                                                            </v-icon>
                                                        </template>
                                                        open Git Repository
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-radio
                                        label="Create New Repository"
                                        value="createNewRepo"
                                    ></v-radio>
                                </v-radio-group>
                            <v-row no-gutters>
                                <v-col cols="5">  
                                    <v-autocomplete
                                        v-if="item.tabKey == 'setFirstRepo' || item.tabKey == 'changeRepo'"
                                        @click="getGitOrganizations()"
                                        @change="OrgNameChanged()"
                                        v-model="gitOrgName"
                                        :items="gitOrganizations"
                                        label="Organization Name"
                                        outlined
                                        dense
                                        auto-select-first
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="7">
                                    <v-text-field
                                        v-if="item.tabKey == 'setFirstRepo' || item.tabKey == 'changeRepo'"
                                        style="margin-left: 10px; margin-top: -5px;"
                                        v-model="gitRepoName"
                                        :error="isDuplicate"
                                        :error-messages="duplicateErrorMessage"
                                        :rules="[gitInfoRules.required]"
                                        label="Repository Name"
                                        @change="RepoNameChanged()"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        <div :key="copyInfoKey" v-if="item.tabKey == 'info'" style="margin: 10px;">
<!--                            <div v-if="(!isFirstCommit || isDuplicate)">-->
                            <div>
                                <span style = "font-weight:700; font-size:14px;">Local IDE</span><br />
                                <span style = "font-weight:500; font-size:13px;"><b style="font-size:17px;">&middot;</b>&nbsp;Clone git Repo firstly</span>
                                <v-text-field
                                    id="copy-gitClone-command"
                                    label="Local IDE"
                                    :value="gitCloneCommand"
                                    prepend-inner-icon="mdi-chevron-right"
                                    solo
                                    readonly
                                    style="margin-right:25px;"
                                >
                                    <template v-slot:append>
                                        <v-icon color="success" v-if="isCopied == 'gitClone_Command'">
                                            mdi-check
                                        </v-icon>
                                        <v-icon v-else @click="copytoClipBoard('gitClone_Command')">
                                            mdi-content-copy
                                        </v-icon>
                                    </template>
                                </v-text-field>

                                <span style = "font-weight:700; font-size:14px;">Cloud IDE</span>
                                <v-text-field
                                    id="copy-gitpod-url"
                                    label="Cloud IDE"
                                    :value="gitpodUrl"
                                    prepend-inner-icon="mdi-chevron-right"
                                    solo
                                    readonly
                                    style="margin-right:25px;"
                                >
                                    <template v-slot:append>
                                        <v-icon color="success" v-if="isCopied == 'gitpod_url'">
                                            mdi-check
                                        </v-icon>
                                        <v-icon v-else @click="copytoClipBoard('gitpod_url')">
                                            mdi-content-copy
                                        </v-icon>
                                    </template>
                                    <template v-slot:append-outer>
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" @click="openGitpod()">
                                                    mdi-open-in-new
                                                </v-icon>
                                            </template>
                                            open GitPod
                                        </v-tooltip>
                                    </template>
                                </v-text-field>

                                <v-divider style="margin: 5px;" />
                            </div>
                            <span style = "font-weight:700; font-size:14px;">Update from model code</span>
                            <v-text-field
                                id="copy-gitMerge-command"
                                label="Update from model code"
                                :value="gitMergeCommand"
                                prepend-inner-icon="mdi-chevron-right"
                                solo
                                readonly
                                style="margin-right:25px;"
                            >
                                <template v-slot:append>
                                    <v-icon color="success" v-if="isCopied == 'gitMerge_Command'">
                                        mdi-check
                                    </v-icon>
                                    <v-icon v-else @click="copytoClipBoard('gitMerge_Command')">
                                        mdi-content-copy
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </div>

                        <span v-if="item.tabKey == 'push'" style = "font-weight:500; font-size:16px;">Target URL</span>
                        <v-text-field
                            v-if="item.tabKey == 'push'"
                            :key="copyPushKey"
                            readonly
                            id="copy-gitRepo-link"
                            prepend-inner-icon="mdi-link-variant"
                            solo
                            v-model="gitRepoUrl"
                            label="gitRepo Link"
                        >
                            <template v-slot:append>
                                <v-icon color="success" v-if="isCopied == 'gitRepo_link'">
                                    mdi-check
                                </v-icon>
                                <v-icon v-else @click="copytoClipBoard('gitRepo_link')">
                                    mdi-content-copy
                                </v-icon>
                            </template>
                            <template v-if="(!isFirstCommit || isDuplicate)" v-slot:append-outer>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="openGitRepo()">
                                            mdi-open-in-new
                                        </v-icon>
                                    </template>
                                    open Git Repository
                                </v-tooltip>
                            </template>
                        </v-text-field>
                            

                        <v-textarea
                            v-if="item.tabKey == 'push'"
                            v-model="gitCommitMessage"
                            auto-grow
                            filled
                            color="primary"
                            label="Commit Message"
                            rows="1"
                        ></v-textarea>
                    </div>
                    
                    <div style="margin: 10px; float: right;">
                        <v-snackbar 
                            v-model="gitSnackBar.show"
                            :timeout="gitSnackBar.timeout"
                            auto-height 
                            :color="gitSnackBar.Color"
                            multi-line
                        >
                            <v-layout align-center pr-4>
                                <v-icon v-if="gitSnackBar.icon" class="pr-3" dark large>{{ gitSnackBar.icon }}</v-icon>
                                <v-layout column>
                                <div v-if="gitSnackBar.title"> 
                                    <strong>{{ gitSnackBar.title }}</strong>
                                </div>
                                <div>{{ gitSnackBar.Text }}</div>
                                </v-layout>
                            </v-layout>
                            <template v-slot:action="{ attrs }">
                                <v-btn
                                    v-if="gitSnackBar.title == 'Warning' && gitSnackBar.Text == 'Nothing changed' && !isOnPrem"
                                    color="white"
                                    outlined
                                    small
                                    v-bind="attrs"
                                    @click="forcePush()"
                                >
                                    force push
                                </v-btn>
                                <v-btn
                                    color="white"
                                    text
                                    small
                                    v-bind="attrs"
                                    @click="gitSnackBar.show = false"
                                >
                                    Close
                                </v-btn>
                            </template>
                        </v-snackbar>
                        <div v-if="!isPushing && item.tabKey == 'setFirstRepo' && gitRadios == 'createNewRepo'">
                            <v-btn v-if="isOnPrem" :disabled="!gitOrgName || !gitRepoName || isDuplicate" text color="primary" @click="startCommitWithGitLab()">Create</v-btn>
                            <v-btn v-else :disabled="!gitOrgName || !gitRepoName || isDuplicate" text color="primary" @click="startGitCommit()">Create</v-btn>
                        </div>
                        <div>
                            <v-btn v-if="item.tabKey == 'changeRepo'" 
                                :disabled="!(gitOrgName && gitRepoName)"
                                text color="primary" @click="gitTab = 1">next
                            </v-btn>
                            <v-btn v-if="!isPushing && item.tabKey == 'setFirstRepo' && gitRadios == 'fork' && isOnPrem" 
                                :disabled="!isListSettingDone || !(gitOrgName && gitRepoName) || isDuplicate"
                                text color="primary" @click="startGitlabFork()">fork
                            </v-btn>
                            <v-btn v-if="!isPushing && item.tabKey == 'setFirstRepo' && gitRadios == 'fork' && !isOnPrem" 
                                :disabled="!isListSettingDone || !(gitOrgName && gitRepoName) || isDuplicate"
                                text color="primary" @click="startGitFork()">fork
                            </v-btn>

                            <v-btn-toggle v-if="!isPushing && item.tabKey == 'push'">
                                <v-btn v-if="isOnPrem"
                                    :disabled="!isListSettingDone || !(gitOrgName && gitRepoName) || !isMineProject || (isFirstCommit && !isDuplicate)"
                                    text color="primary" @click="startCommitWithGitLab()">{{ pushBtnName }}
                                </v-btn>
                                <v-btn v-if="!isOnPrem"
                                    :disabled="!isListSettingDone || !(gitOrgName && gitRepoName) || !isMineProject || (isFirstCommit && !isDuplicate)"
                                    text color="primary" @click="startGitCommit()">{{ pushBtnName }}
                                </v-btn>
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon 
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in pushBtnitems"
                                            :key="index"
                                            @click="pushType = item.title"
                                            :disabled="pushType == item.title"
                                        >
                                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-btn-toggle>
        
                            <span v-if="isPushing && (item.tabKey == 'push' || item.tabKey == 'setFirstRepo')">
                                <b :key="commitStep" v-if="commitStepText != null">{{ commitStepText }}({{commitStep}}%) ... </b>
                                <v-progress-circular
                                    indeterminate
                                    color="primary"
                                ></v-progress-circular>
                            </span>
                        </div>
                    </div>
                </v-card>
            </v-tab-item>
        </v-tabs>
    </v-card>

    <v-card v-else :disabled="!isListSettingDone" style="width: 350px; height: 380px;">
        <v-card-title style="background-color: #0d1117; color: white; margin-left:-10px;">
            <v-icon color="white" @click="gitMenuMode = 'push'" style="margin-right: 5px;">mdi-arrow-left</v-icon>
            &nbsp;Settings
            <v-spacer />
        </v-card-title>
        <div style="margin: 10px;">
            <div v-if="isGitLogin" style="width: 100%; text-align: right; margin-bottom: -30px;">
                <v-btn small text color="primary" @click="logoutToGit()">sign out</v-btn>
            </div>
            <div v-if="!isGitLogin" style="width: 100%; text-align: center; font-size: 20px;">
                <login-by-gitlab v-if="isOnPrem"></login-by-gitlab>
                <Login v-else :isGitMenu="true" @isGitLogin="isGitLoginComplete()"></Login>
            </div>
            <div v-else style="width: 100%; text-align: center; margin-bottom: 10px;">
                <v-avatar class="ma-0">
                    <img
                        :src=gitPicture
                    >
                </v-avatar>
            </div>
            <div v-if="!isGitLogin" style="width: 100%; text-align: center; margin-top: 10px;"><b style="color: grey;">or</b></div>
                <v-text-field
                    v-model="gitUserName"
                    :readonly="isGitLogin"
                    :rules="[gitInfoRules.required]"
                    label="userName"
                ></v-text-field>
                <v-text-field
                    :append-icon="showToken ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showToken ? 'text' : 'password'"
                    @click:append="showToken = !showToken"
                    v-model="gitToken"
                    :readonly="isGitLogin"
                    :rules="[gitInfoRules.required]"
                    label="token"
                >
                    <template v-slot:label>
                        Access Token
                        <v-icon @click="openGuide()" style="vertical-align: middle; margin-top: -3px;">
                            mdi-help-circle-outline
                        </v-icon>
                    </template>
                </v-text-field>
                <v-switch
                    v-model="usegitPod"
                    label="Using gitpod to open Project IDE"
                    @change="changedUseGitPodStatus()"
                ></v-switch>
            </div>
        </v-card>
    </div>
</template>

<script>
    import labBase from "../labs/LabStorageBase"
    import Login from "../oauth/Login"
    import LoginByGitlab from "../oauth/LoginByGitlab";
    const axios = require('axios');

    export default {
        name: 'gitAPIMenu',
        mixins: [labBase],
        components: {
            LoginByGitlab,
            Login
        },
        props: {
            isOnPrem: Boolean,
            changedPathListsForGit: Array,
            fullPathList: Array,   
            getCodeList: Array,       
            projectId: String,           
            projectName: String,      
            mergeCodeList: Object,     
            isListSettingDone: Boolean,
            isMineProject: Boolean,
            information: Object,
            gitUsers: Object
        },
        data() {
            return {
                firstSetUserName: true,
                pushBtnName: "Push",
                pushType: "Push",
                pushBtnitems: [
                    { title: 'Push' },
                    { title: 'Force Push' },
                ],
                gitlabGroupIdList: {},
                gitlabDomain: null,
                gitHeaders: {},
                copyChangedPathLists: [],
                gitCommitMessage: null,
                duplicateErrorMessage: null,
                isDuplicate: false,
                repoList: [],
                isCopied: null,
                gitRadios: null,
                firstTimeGet: true,
                gitForkOrgName: null,
                gitForkRepoName: null,
                gitOrgName: null,
                gitOrganizations: [],
                copyPushKey: 0,
                copyInfoKey: 0,
                gitTabKey: 0,
                gitTab: 0,
                isGitLogin: false,
                gitMenuMode: 'push',
                gitInfoRules: {
                   required: value => !!value || 'Required.'
                },
                commitStep: 0,
                commitStepSetTimeout: null,
                commitStepText: null,

                parentsCommitSha: null,
                usegitPod: true,
                gitSnackBar: {
                    Text: '',
                    show: false,
                    Color: null,
                    icon: null,
                    title: null,
                    timeout: null,
                },
                firstCommit: false,
                isFirstCommit: true,
                gitMenu: false,
                isPushing: false,
                gitAvatarHover: false,
                gitPicture: null,
                gitToken: null,
                showToken: false,
                gitUserName: null,
                gitRepoName: null,
                getRoofCnt: 0,
                treesha: null,
                pushTree: [],
                removeTree: [],
                gitTreeList: [],
                gitlabFileList: [],	
                gitlabFilePathList: [],	
                gitLabCommitAction: [],	
                isNewProject: false,	
                gitLabProjectId: null
            }
        },
        computed: {
            gitpodUrl(){
                if(this.isFirstCommit){
                    if(this.information){
                        if(!this.information.forkedByModelGitOrgName || !this.information.forkedByModelGitRepoName){
                                return `https://gitpod.io/#https://github.com/${this.gitOrgName}/${this.gitRepoName}/tree/main`
                        } else {
                            if(this.isOnPrem){
                                return `https://gitpod.io/#https://gitlab.${this.gitlabDomain}/${this.information.forkedByModelGitOrgName}/${this.information.forkedByModelGitRepoName}/tree/main`
                            } else {
                                return `https://gitpod.io/#https://github.com/${this.information.forkedByModelGitOrgName}/${this.information.forkedByModelGitRepoName}/tree/main`
                            }
                        }
                    }
                } else {
                    if(this.isOnPrem){
                        return `https://gitpod.io/#https://gitlab.${this.gitlabDomain}/${this.gitOrgName}/${this.gitRepoName}/tree/main`
                    } else {  
                        return `https://gitpod.io/#https://github.com/${this.gitOrgName}/${this.gitRepoName}/tree/main`
                    }
                }
            },
            gitCloneCommand(){
                if(this.isFirstCommit){
                    if(this.information){
                        if(!this.information.forkedByModelGitOrgName || !this.information.forkedByModelGitRepoName){
                                return `git clone https://github.com/${this.gitOrgName}/${this.gitRepoName}.git`
                        } else {
                            if(this.isOnPrem){
                                return `git clone https://gitlab.${this.gitlabDomain}/${this.information.forkedByModelGitOrgName}/${this.information.forkedByModelGitRepoName}.git`
                            } else {
                                return `git clone https://github.com/${this.information.forkedByModelGitOrgName}/${this.information.forkedByModelGitRepoName}.git`
                            }
                        }
                    }
                } else {
                    if(this.isOnPrem){
                        return `git clone https://gitlab.${this.gitlabDomain}/${this.gitOrgName}/${this.gitRepoName}.git`
                    } else {    
                        return `git clone https://github.com/${this.gitOrgName}/${this.gitRepoName}.git`
                    }
                }
            },
            gitMergeCommand(){
                return `git pull && git merge origin/template`
            },
            gitTabItems(){
                var me = this
                var setTabItems
                if(me.isMineProject){
                    if(me.isFirstCommit){
                        setTabItems = [
                            { tab: 'Repository', index: 1, tabKey: 'setFirstRepo' },
                            { tab: 'Push', index: 2, tabKey: 'push' },
                            { tab: 'IDE', tabKey: 'info', index: 3 },
                        ]
                    } else {
                        setTabItems = [
                            { tab: 'Repository', index: 1, tabKey: 'changeRepo' },
                            { tab: 'Push', index: 2, tabKey: 'push' },
                            { tab: 'IDE', tabKey: 'info', index: 3 }
                        ]
                    }
                } else {
                    setTabItems = [
                        { tab: 'IDE', tabKey: 'info', index: 1 }
                    ]
                }

                return setTabItems
            },
            gitRepoUrl() {
                if(this.isOnPrem){
                    return `https://gitlab.${this.gitlabDomain}/${this.gitOrgName}/${this.gitRepoName}`
                } else {
                    return `https://github.com/${this.gitOrgName}/${this.gitRepoName}`
                }
            },
            gitRefRepoUrl(){
                if(this.information){
                    if(!this.information.forkedByModelGitOrgName || !this.information.forkedByModelGitRepoName){
                        this.gitRadios = "createNewRepo"
                        return false
                    } else {
                        if(this.isOnPrem){
                            return `https://gitlab.${this.gitlabDomain}/${this.information.forkedByModelGitOrgName}/${this.information.forkedByModelGitRepoName}`
                        } else {
                            return `https://github.com/${this.information.forkedByModelGitOrgName}/${this.information.forkedByModelGitRepoName}`
                        }
                    }
                } else {
                    this.gitRadios = "createNewRepo"
                    return false
                }
            }
        },
        created: async function () {},
        mounted: function () {
            var me = this
            me.setGitInfo()
        },
        watch: {
            pushType(newVal) {
                if(newVal == 'Push'){
                    this.pushBtnName = "Push"
                } else {
                    this.pushBtnName = "Force Push"
                }
            },
            gitUsers(newVal) {
                console.log(newVal);
                this.gitToken = newVal.data.accessToken;
                this.gitUserName = newVal.data.username;
                this.gitPicture = newVal.data.avatar_url;
            },
            gitUserName: _.debounce(function () {
                if(this.isMineProject && (!this.firstSetUserName || !this.gitOrgName)){
                    this.gitOrganizations = []
                    this.firstTimeGet = true
                    if(this.gitUserName){
                        this.gitOrgName = this.gitUserName
                        this.gitOrganizations.push(this.gitUserName)
                        localStorage.setItem("gitUserName", this.gitUserName);
                    } else {
                        localStorage.removeItem("gitUserName");
                        this.gitOrgName = null
                    }
                } else {
                    this.firstSetUserName = false
                }
            }, 1000),
            gitToken: _.debounce(function (newVal) {
                var me = this
                if(newVal){
                    localStorage.setItem("gitToken", newVal);
                    if(me.isOnPrem){
                        this.gitHeaders = {
                            Authorization: 'Bearer ' + newVal,
                            Accept: 'application/json'
                        }
                    } else {
                        this.gitHeaders = {
                            Authorization: 'token ' + me.gitToken,
                            Accept: 'application/vnd.github+json'
                        }
                    }
                } else {
                    localStorage.removeItem("gitToken");
                }
            }, 1000),
            commitStepText: function (newVal) {
                var me = this
                if(newVal == null){
                    if(me.commitStepSetTimeout){
                        clearTimeout(me.commitStepSetTimeout)
                    }
                    me.commitStep = 0
                } else if(newVal == 'Started Commit'){
                    me.commitStepSetTimeout = setTimeout(function () {
                        if(me.commitStep < 30){
                            me.commitStep++;
                        } else {
                            clearTimeout(me.commitStepSetTimeout)
                        }
                    }, 300)
                } else if(newVal == 'Check Git Repo'){
                    clearTimeout(me.commitStepSetTimeout)
                    me.commitStep = 30
                    me.commitStepSetTimeout = setTimeout(function () {
                        if(me.commitStep < 50){
                            me.commitStep++;
                        } else {
                            clearTimeout(me.commitStepSetTimeout)
                        }
                    }, 300)
                } else if(newVal == 'Set Git Commit Tree'){
                    clearTimeout(me.commitStepSetTimeout)
                    me.commitStep = 50
                    me.commitStepSetTimeout = setTimeout(function () {
                        if(me.commitStep < 70){
                            me.commitStep++;
                        } else {
                            clearTimeout(me.commitStepSetTimeout)
                        }
                    }, 300)
                } else if(newVal == 'Commit to Git'){
                    clearTimeout(me.commitStepSetTimeout)
                    me.commitStep = 70
                    me.commitStepSetTimeout = setTimeout(function () {
                        if(me.commitStep < 90){
                            me.commitStep++;
                        } else {
                            clearTimeout(me.commitStepSetTimeout)
                        }
                    }, 300)
                } else if(newVal == 'Push to Git'){
                    clearTimeout(me.commitStepSetTimeout)
                    me.commitStep = 90
                    me.commitStepSetTimeout = setTimeout(function () {
                        if(me.commitStep < 100){
                            me.commitStep++;
                        } else {
                            clearTimeout(me.commitStepSetTimeout)
                        }
                    }, 300)
                }
            },
        },
        methods: {
            async addGitPodYaml(){
                var me = this
                let gitPodYamldata = {
                    content: `# This configuration file was automatically generated by Gitpod.\n# Please adjust to your needs (see https://www.gitpod.io/docs/config-gitpod-file)\n# and commit this file to your remote git repository to share the goodness with others.\n\ntasks:\n - init: sudo chmod u+x init.sh && ./init.sh`,
                    encoding: 'utf-8',
                };
                let creatreGitPodYamldata = await axios.post(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/blobs`, gitPodYamldata, { headers: me.gitHeaders })
                .catch(function (error) {
                    if(error.response && error.response.data && error.response.data.message){
                        var errText = error.response.data.message
                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                            errText = errText + ', ' + error.response.data.errors[0].message
                        }
                        me.showErrSnackBar(errText)
                    } else {
                        me.showErrSnackBar(error.message)
                    }
                }); 
                if(creatreGitPodYamldata){
                    let pushData = {
                        path: ".gitpod.yml", 
                        mode:"100644",
                        type:"blob",
                        sha: creatreGitPodYamldata.data.sha
                    }
                    me.pushTree.push(pushData)
                }
            },
            async addInitShell(){
                var me = this
                let initShelldata = {
                    content: `sudo apt-get update\nsudo apt-get install net-tools\nsudo apt install iputils-ping\npip install httpie\n\ncurl -LO "https://dl.k8s.io/release/$(curl -L -s https://dl.k8s.io/release/stable.txt)/bin/linux/amd64/kubectl"\nsudo install -o root -g root -m 0755 kubectl /usr/local/bin/kubectl\n\ncurl "https://awscli.amazonaws.com/awscli-exe-linux-x86_64.zip" -o "awscliv2.zip"\nunzip awscliv2.zip\nsudo ./aws/install\n\ncurl --silent --location "https://github.com/weaveworks/eksctl/releases/latest/download/eksctl_$(uname -s)_amd64.tar.gz" | tar xz -C /tmp\nsudo mv /tmp/eksctl /usr/local/bin\n\ncd kafka\ndocker-compose up`,
                    encoding: 'utf-8',
                };
                let creatreInitShellres = await axios.post(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/blobs`, initShelldata, { headers: me.gitHeaders })
                .catch(function (error) {
                    if(error.response && error.response.data && error.response.data.message){
                        var errText = error.response.data.message
                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                            errText = errText + ', ' + error.response.data.errors[0].message
                        }
                        me.showErrSnackBar(errText)
                    } else {
                        me.showErrSnackBar(error.message)
                    }
                }); 
                if(creatreInitShellres){
                    let pushData = {
                        path: "init.sh", 
                        mode:"100644",
                        type:"blob",
                        sha: creatreInitShellres.data.sha
                    }
                    me.pushTree.push(pushData)
                }
            },
            closeMenu(){
                this.$emit("closeMenu")
            },
            async startCommitWithGitLab(){
                var me = this 
                try {
                    me.commitStepText = 'Started Commit'
                    me.isPushing = true
                    me.gitLabProjectId = null
                    me.gitLabCommitAction = []
                    if(me.projectId){
                        me.setString(`db://definitions/${me.projectId}/information/gitOrgName`, me.gitOrgName)
                        me.setString(`db://definitions/${me.projectId}/information/gitRepoName`, me.gitRepoName)
                    }
                    // var config = {headers: {Authorization: 'Bearer ' + me.gitToken}};

                    var response1 = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/users?username=${me.gitUserName}`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                    .catch(function (error) {
                        if(error.response && error.response.data && error.response.data.message){
                            var errText = error.response.data.message
                            if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                errText = errText + ', ' + error.response.data.errors[0].message
                            }
                            me.showErrSnackBar(errText)
                        } else {
                            me.showErrSnackBar(error.message)
                        }
                    }); 
                    console.log(response1);

                    // 내 프로젝트 목록 
                    me.commitStepText = 'Check Git Repo'
                    var response2 = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/users/${response1.data[0].id}/projects`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                    .catch(function (error) {
                        if(error.response && error.response.data && error.response.data.message){
                            var errText = error.response.data.message
                            if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                errText = errText + ', ' + error.response.data.errors[0].message
                            }
                            me.showErrSnackBar(errText)
                        } else {
                            me.showErrSnackBar(error.message)
                        }
                    }); 
                    console.log(response2);

                    var dataArry = response2.data

                    dataArry.some(function (data) {
                        // console.log(data.name)
                        // repoName
                        if(data.name == me.gitRepoName) {
                            me.gitLabProjectId = data.id
                            return true;
                        }
                    })
                    
                    if(!me.gitLabProjectId){
                        me.commitStepText = 'Create New Repo'
                        me.isNewProject = true

                        let newProjectData = {
                            name: me.gitRepoName,
                            description: me.gitRepoName,
                            path: me.gitRepoName,
                            visibility: "public",
                            // namespace_id: "42", 
                            initialize_with_readme: "true"
                        }
                        console.log(me.gitHeaders);
                        var createProjectRes = await me.$http.post(`https://gitlab.${me.gitlabDomain}/api/v4/projects`, newProjectData, {headers: {Authorization: 'Bearer ' + me.gitToken}});
                        me.gitLabProjectId = createProjectRes.data.id
                    }
                    if(me.gitLabProjectId){
                        var branchName 
                        if(me.isNewProject){
                            branchName = "main"
                        } else{
                            branchName = "template"
                        }
                        var getFilePathList = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/projects/${me.gitLabProjectId}/repository/tree?ref=${branchName}&id=${me.gitLabProjectId}&page=1&per_page=100&pagination=keyset&recursive=true`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        me.gitlabFileList = me.gitlabFileList.concat(getFilePathList.data)
                        var totalPage = parseInt(getFilePathList.headers['x-total-pages'])
                        
                        for(var i = 2; i <= totalPage; i++){
                            var getMoreFilePathList = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/projects/${me.gitLabProjectId}/repository/tree?ref=${branchName}&id=${me.gitLabProjectId}&page=${i}&per_page=100&pagination=keyset&recursive=true`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                            .catch(function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            me.gitlabFileList = me.gitlabFileList.concat(getMoreFilePathList.data)
                            console.log(me.gitlabFileList)
                        }

                        me.setCommitListGitLab()
                    }
                } catch (error) {
                    console.error(error);
                }
            },
            async setCommitListGitLab(){
                var me = this
                me.commitStepText = 'Set Git Commit Tree'
                me.gitlabFilePathList = []
                me.gitlabFileList.forEach(function (data) {
                    if(data.type == "blob"){
                        me.gitlabFilePathList.push(data.path)
                    } 
                })
                console.log(me.gitlabFilePathList)
                // var config = {headers: {Authorization: 'Bearer ' + me.gitToken}};
                me.gitlabFilePathList.forEach(function (elData) {
                    if(!me.fullPathList.find(element => element.fullPath == elData)){
                        var action = {
                            action: "delete",
                            file_path: elData,
                        }
                        me.gitLabCommitAction.push(action)
                    } 
                })

                me.fullPathList.forEach(function (elData) {
                    if(!me.gitlabFilePathList.find(element => element == elData.fullPath)){
                        var code
                        if(elData.key){
                            Object.keys(me.mergeCodeList).some(function (key) {
                                if(key == elData.fullPath){
                                    code = me.mergeCodeList[key].code
                                    return true;
                                }
                            })
                            if(!code){
                                var fileCode = me.getCodeList.find(getCodeElement => getCodeElement.key == elData.key)
                                if(fileCode && fileCode.code){
                                    code = fileCode.code
                                }
                            }
                        } else if(elData.code){
                            code = elData.code
                        }
    
                        if(!code){
                            code = 'undefined'
                        }
                        var action = {
                            action: "create",
                            file_path: elData.fullPath,
                            content: code
                        }
                        me.gitLabCommitAction.push(action)
                    } else if(!me.isNewProject && ((me.copyChangedPathLists && me.copyChangedPathLists.find(element => element.replace("for-model/","") == elData.fullPath)) || me.pushType != "Push")){
                        var code
                        if(elData.key){
                            Object.keys(me.mergeCodeList).some(function (key) {
                                if(key == elData.fullPath){
                                    code = me.mergeCodeList[key].code
                                    return true;
                                }
                            })
                            if(!code){
                                var fileCode = me.getCodeList.find(getCodeElement => getCodeElement.key == elData.key)
                                if(fileCode && fileCode.code){
                                    code = fileCode.code
                                }
                            }
                        } else if(elData.code){
                            code = elData.code
                        }
    
                        if(!code){
                            code = 'undefined'
                        }
                        var action = {
                            action: "update",
                            file_path: elData.fullPath,
                            content: code
                        }
                        me.gitLabCommitAction.push(action)
                    }
                })
                console.log(me.gitLabCommitAction)

                var setCommitActionList 
                me.gitLabCommitAction.reduce(function(acc, current) {
                    if (acc.findIndex(({ file_path }) => file_path === current.file_path) === -1) {
                        acc.push(current);
                    }
                    setCommitActionList = acc
                    return acc;
                }, []);

                if(setCommitActionList) {
                    me.commitStepText = 'Push to Git'
                    var commitMsg
                    if(me.gitCommitMessage){
                        commitMsg = me.gitCommitMessage
                    } else {
                        commitMsg = "commit"
                    }
                    if(me.isNewProject){
                        let committoMainData = {
                            branch: "main",
                            commit_message: commitMsg,
                            actions: setCommitActionList,
                        }
                        var pushtoMainRes = await axios.post(`https://gitlab.${me.gitlabDomain}/api/v4/projects/${me.gitLabProjectId}/repository/commits`, committoMainData, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        console.log(pushtoMainRes)
                        if(pushtoMainRes){ 
                            var createBranchRes = await axios.post(`https://gitlab.${me.gitlabDomain}/api/v4/projects/${me.gitLabProjectId}/repository/branches?branch=template&ref=main`, {}, { headers: me.gitHeaders })
                            .catch(function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            console.log(createBranchRes)
                        }
                    } else {
                        let commitData = {
                            branch: "template",
                            commit_message: commitMsg,
                            actions: setCommitActionList,
                        }
                        var response4 = await axios.post(`https://gitlab.${me.gitlabDomain}/api/v4/projects/${me.gitLabProjectId}/repository/commits`, commitData, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        console.log(response4)
                    }
                    
                    me.setString(`db://definitions/${me.projectId}/information/firstCommit`, "false")
                    me.isPushing = false
                    me.isNewProject = false
                    me.isFirstCommit = false
                    me.gitTabKey++;
                    me.gitTab = 2
                    me.commitStepText = null
                    me.gitCommitMessage = null
                    me.gitlabFileList = []
                    me.gitlabFilePathList = []
                    me.gitLabCommitAction = []
                    me.copyChangedPathLists = []
                    me.gitSnackBar.show = true
                    me.gitSnackBar.timeout = 3000
                    me.gitSnackBar.Text = "Commit/Push 완료되었습니다."
                    me.gitSnackBar.Color = "success"
                    me.gitSnackBar.icon="check_circle"
                    me.gitSnackBar.title="Success"
                } else {
                    me.isPushing = false
                    me.commitStepText = null
                    me.gitSnackBar.show = true
                    me.gitSnackBar.timeout = -1
                    me.gitSnackBar.Text = "Nothing changed"
                    me.gitSnackBar.Color = "warning"
                    me.gitSnackBar.icon="warning"
                    me.gitSnackBar.title="Warning"
                }
            },  
            async startGitlabFork(){
                var me = this 
                try {
                    me.isPushing = true
                    if(me.projectId){
                        me.setString(`db://definitions/${me.projectId}/information/gitOrgName`, me.gitOrgName)
                        me.setString(`db://definitions/${me.projectId}/information/gitRepoName`, me.gitRepoName)
                    }
                    let forkData = {
                        path: me.gitRepoName,
                        name: me.gitRepoName
                    };
                    
                    let forkRes = await axios.post(`https://gitlab.${me.gitlabDomain}/api/v4/projects/13/fork`, forkData, { headers: me.gitHeaders })
                    .catch(function (error) {
                        if(error.response && error.response.data && error.response.data.message){
                            var errText = error.response.data.message
                            if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                errText = errText + ', ' + error.response.data.errors[0].message
                            }
                            me.showErrSnackBar(errText)
                        } else {
                            me.showErrSnackBar(error.message)
                        }
                    }); 
                    console.log(forkRes)
                    if(forkRes){
                        me.setString(`db://definitions/${me.projectId}/information/firstCommit`, "false")
                        me.isFirstCommit = false
                        me.gitTabKey++;
                        me.gitTab = 2
                        me.gitCommitMessage = null
                        me.isPushing = false
                        me.gitSnackBar.show = true
                        me.gitSnackBar.timeout = 3000
                        me.gitSnackBar.Text = "Fork 완료되었습니다."
                        me.gitSnackBar.Color = "success"
                        me.gitSnackBar.icon="check_circle"
                        me.gitSnackBar.title="Success"
                    }
                } catch(e) {
                    me.showErrSnackBar(e.message)
                }
            },
            async setGitInfo(){
                var me = this
                if(me.isOnPrem){
                    me.gitlabDomain = window.location.host.replace("www.", "")
                    // me.gitlabDomain = "msastudy.io"

                    if(localStorage.getItem('gitToken')){ 
                        me.gitToken = localStorage.getItem('gitToken')
                    }
                    
                    me.gitHeaders = {
                        Authorization: 'Bearer ' + me.gitToken,
                        Accept: 'application/json'
                    }
                    
                    if(localStorage.getItem('gitUserName')){
                        me.gitUserName = localStorage.getItem('gitUserName')
                    }

                    if(localStorage.getItem('picture')){
                        me.gitPicture = localStorage.getItem('picture')
                    }
                    
                    if(localStorage.getItem('loginType') && localStorage.getItem('loginType') == 'gitlab'){
                        me.isGitLogin = true
                    }
                } else {
                    if(localStorage.getItem('gitToken')){
                        me.gitToken = localStorage.getItem('gitToken')
                    }
    
                    me.gitHeaders = {
                        Authorization: 'token ' + me.gitToken,
                        Accept: 'application/vnd.github+json'
                    }
                        
                    if(localStorage.getItem('gitUserName')){
                        me.gitUserName = localStorage.getItem('gitUserName')
                    }
    
                    if(localStorage.getItem('picture')){
                        me.gitPicture = localStorage.getItem('picture')
                    }
                    
                    if(localStorage.getItem('loginType') && localStorage.getItem('loginType') == 'github'){
                        me.isGitLogin = true
                    }

                }
                if(!me.gitUserName || !me.gitToken){
                    me.gitMenuMode = "settings"
                }
                if(localStorage.getItem("forkedModelInfo")){
                    if(localStorage.getItem("forkedModelInfo").includes('gitOrgName')){
                        var beforeModelInfo = JSON.parse(JSON.parse(localStorage.getItem("forkedModelInfo")))
                        if(beforeModelInfo && beforeModelInfo.gitOrgName != null){
                            me.gitForkOrgName = beforeModelInfo.gitOrgName
                            me.gitForkRepoName = beforeModelInfo.gitRepoName
                            me.setString(`db://definitions/${me.projectId}/information/forkedByModelGitOrgName`, me.gitForkOrgName)
                            me.setString(`db://definitions/${me.projectId}/information/forkedByModelGitRepoName`, me.gitForkRepoName)
                        }
                    }

                    localStorage.removeItem("forkedModelInfo")
                }

                me.copyChangedPathLists = JSON.parse(JSON.stringify(me.changedPathListsForGit))

                if(me.information){
                    if(me.information.gitRepoName){
                        me.gitRepoName = me.information.gitRepoName
                        me.gitForkRepoName = me.information.gitRepoName
                    } else if(me.information.projectName){
                        me.gitRepoName = me.information.projectName
                    }

                    me.gitOrganizations.push(me.gitUserName)

                    if(me.information.gitOrgName){
                        me.gitOrgName = me.information.gitOrgName
                        if(me.gitOrgName != me.gitUserName){
                            me.gitOrganizations.push(me.gitOrgName)
                        }
                    } else {
                        me.gitOrgName = me.gitUserName
                    }


                    if(me.information.firstCommit == "false"){
                        me.isFirstCommit = false
                    }
                    
                    if(me.isFirstCommit){
                        if(me.information.forkOrigin){
                            if(me.information.forkedByModelGitOrgName && me.information.forkedByModelGitRepoName){
                                me.gitForkOrgName = me.information.forkedByModelGitOrgName
                                me.gitForkRepoName = me.information.forkedByModelGitRepoName
                            }
                        }
                    }
                    if(!me.information.useIdeItem){
                        me.setString(`db://definitions/${me.projectId}/information/useIdeItem`, 'gitpod')
                    } else if(me.information.useIdeItem == 'theia'){
                        me.usegitPod = false
                    }
                } else {
                    me.gitOrgName = me.gitUserName
                    me.gitOrganizations.push(me.gitOrgName)
                    me.gitRepoName = me.projectName
                    me.setString(`db://definitions/${me.projectId}/information/useIdeItem`, 'gitpod')
                }
                if(this.isMineProject && !this.isFirstCommit){
                    this.gitTab = 1
                } else {
                    this.gitTab = 0 
                }
                
                if(me.gitUserName && me.gitOrgName && me.gitToken){
                    if(me.repoList.length == 0 && this.isFirstCommit){
                        var gitRepoList
                        if(me.isOnPrem){
                            if((this.gitOrgName != this.gitUserName) && this.gitlabGroupIdList[this.gitOrgName]){
                                gitRepoList = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/groups/${this.gitlabGroupIdList[this.gitOrgName]}/projects`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                                .catch(function (error) {
                                    if(error.response && error.response.data && error.response.data.message){
                                        var errText = error.response.data.message
                                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                            errText = errText + ', ' + error.response.data.errors[0].message
                                        }
                                        me.showErrSnackBar(errText)
                                    } else {
                                        me.showErrSnackBar(error.message)
                                    }
                                }); 
                            } else {
                                gitRepoList = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/users/${this.gitOrgName}/projects`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                                .catch(function (error) {
                                    if(error.response && error.response.data && error.response.data.message){
                                        var errText = error.response.data.message
                                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                            errText = errText + ', ' + error.response.data.errors[0].message
                                        }
                                        me.showErrSnackBar(errText)
                                    } else {
                                        me.showErrSnackBar(error.message)
                                    }
                                }); 
                            }
                            console.log(gitRepoList)
                        } else {
                            if(this.gitOrgName != this.gitUserName){
                                gitRepoList = await axios.get(`https://api.github.com/orgs/${this.gitOrgName}/repos`, { headers: me.gitHeaders })
                                .catch(function (error) {
                                    if(error.response && error.response.data && error.response.data.message){
                                        var errText = error.response.data.message
                                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                            errText = errText + ', ' + error.response.data.errors[0].message
                                        }
                                        me.showErrSnackBar(errText)
                                    } else {
                                        me.showErrSnackBar(error.message)
                                    }
                                }); 
                            } else {
                                gitRepoList = await axios.get(`https://api.github.com/users/${this.gitOrgName}/repos`, { headers: me.gitHeaders })
                                .catch(function (error) {
                                    if(error.response && error.response.data && error.response.data.message){
                                        var errText = error.response.data.message
                                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                            errText = errText + ', ' + error.response.data.errors[0].message
                                        }
                                        me.showErrSnackBar(errText)
                                    } else {
                                        me.showErrSnackBar(error.message)
                                    }
                                }); 
                            }
                        }
                        if(gitRepoList){
                            gitRepoList.data.forEach(function (repoInfo) {
                                me.repoList.push(repoInfo.name)
                            })
                            me.checkDuplicate()
                        }
                    }
                }
            },
            openGuide(){
                window.open(`https://github.com/TheOpenCloudEngine/msaschool/wiki/Github-Personal-Access-Token-%EB%B0%9C%ED%96%89-%EB%B0%A9%EB%B2%95`, '_blank');
            },
            checkDuplicate(){
                if(this.repoList.length > 0){
                    if(this.repoList.find(repo => repo == this.gitRepoName)){
                        this.isDuplicate = true
                        this.duplicateErrorMessage = `Repository name already exist`
                    } else {
                        this.isDuplicate = false
                        this.duplicateErrorMessage = null
                    }
                }
            },
            async RepoNameChanged(){
                this.gitTreeList = []
                this.checkDuplicate()
            },
            async OrgNameChanged(){
                var me = this
                me.gitTreeList = []
                me.repoList = []

                var gitRepoList
                if(me.isOnPrem){
                    if((this.gitOrgName != this.gitUserName) && this.gitlabGroupIdList[this.gitOrgName]){
                        gitRepoList = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/groups/${this.gitlabGroupIdList[this.gitOrgName]}/projects`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                    } else {
                        gitRepoList = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/users/${this.gitOrgName}/projects`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                    }
                    console.log(gitRepoList)
                } else {
                    if(this.gitOrgName != this.gitUserName){
                        gitRepoList = await axios.get(`https://api.github.com/orgs/${this.gitOrgName}/repos`, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                    } else {
                        gitRepoList = await axios.get(`https://api.github.com/users/${this.gitOrgName}/repos`, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                    }
                }
                if(gitRepoList){
                    gitRepoList.data.forEach(function (repoInfo) {
                        me.repoList.push(repoInfo.name)
                    })
                    me.checkDuplicate()
                }
            },
            async getGitOrganizations(){
                var me = this
                if(me.firstTimeGet){
                    if(me.isOnPrem){
                        var gitlabGroups = await axios.get(`https://gitlab.${me.gitlabDomain}/api/v4/groups`, {headers: {Authorization: 'Bearer ' + me.gitToken}})
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        console.log(gitlabGroups)
                        gitlabGroups.data.forEach(function (orgInfo) {
                            me.gitlabGroupIdList[orgInfo.name] = orgInfo.id
                            me.gitOrganizations.push(orgInfo.name)
                        })
                    } else {
                        let gitOrganizationsList = await axios.get(`https://api.github.com/user/orgs`, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        if(gitOrganizationsList && gitOrganizationsList.data.length > 0){
                            gitOrganizationsList.data.forEach(function (orgInfo) {
                                me.gitOrganizations.push(orgInfo.login)
                            })
                        }
                    }
                    me.firstTimeGet = false
                }
            },
            showErrSnackBar(err){
                var me = this
                me.isPushing = false
                me.commitStepText = null
                me.gitSnackBar.timeout = -1
                me.gitSnackBar.show = true
                me.gitSnackBar.Text = err
                me.gitSnackBar.Color = "error"
                me.gitSnackBar.icon="error"
                me.gitSnackBar.title="Error"
            },
            writeUserData(userId, name, email, imageUrl, provider) {
                // var database = firebase.database();
                var authorized = 'admin';
                if (email.includes('@uengine.org')) {
                    authorized = 'admin'
                } else {
                    authorized = 'student'
                }

                var obj = {
                    username: name,
                    email: email,
                    profile_picture: imageUrl,
                    state: 'signIn',
                    provider: provider,
                    authorized: authorized,
                    loginDate: Date.now()
                }
                var eObj = {
                    uid: userId,
                    userName: name,
                    profile_picture: imageUrl,
                    email: email,
                }

                this.putObject(`db://users/${userId}`, obj)
                //새로운 로그인 유저
                if (email) {
                    var convertEmail = email.replace(/\./gi, '_')
                    this.putObject(`db://enrolledUsers/${convertEmail}`, eObj)
                }

            },
            isGitLoginComplete(){
                var me = this 
                me.gitUserName = localStorage.getItem('gitUserName')
                me.gitToken = localStorage.getItem('gitToken')
                me.gitPicture = localStorage.getItem('picture')  
                me.isGitLogin = true
                me.gitMenuMode = "push"
            }, 
            copytoClipBoard(paramKeys) {
                var me = this 
                let copyValue
                if(paramKeys == "gitRepo_link"){
                    copyValue = document.querySelector("#copy-gitRepo-link")
                } else if(paramKeys == "gitMerge_Command"){
                    copyValue = document.querySelector("#copy-gitMerge-command") 
                } else if(paramKeys == "gitpod_url"){
                    copyValue = document.querySelector("#copy-gitpod-url") 
                } else if(paramKeys == "gitClone_Command"){
                    copyValue = document.querySelector("#copy-gitClone-command") 
                }
                document.body.appendChild(copyValue);
                copyValue.select();
                var successful = document.execCommand('copy');
                if(successful) {
                    me.isCopied = paramKeys
                    setTimeout(() => {
                        me.isCopied = null
                    }, 1500)
                } 
                if(paramKeys == 'gitRepo_link'){
                    me.copyPushKey++;
                } else {
                    me.copyInfoKey++;
                }
            },
            openGitRepo(){
                if(this.isOnPrem){
                    window.open(`https://gitlab.${this.gitlabDomain}/${this.gitOrgName}/${this.gitRepoName}`, '_blank');
                } else {
                    window.open(`https://github.com/${this.gitOrgName}/${this.gitRepoName}`, '_blank');
                }
            },
            openGitpod(){
                var me = this
                if (me.isLogin) {
                    if(this.isOnPrem)
                        this.$emit("openIDE", `https://gitlab.${this.gitlabDomain}/${this.gitOrgName}/${this.gitRepoName}`);
                    else
                        window.open(`https://gitpod.io/#https://github.com/${me.gitOrgName}/${me.gitRepoName}/tree/main`, '_blank');
                } else {
                    me.$EventBus.$emit('showLoginDialog')
                }
            },
            changedUseGitPodStatus(){
                var me = this
                if(me.usegitPod){
                    me.setString(`db://definitions/${me.projectId}/information/useIdeItem`, 'gitpod')
                } else {
                    me.setString(`db://definitions/${me.projectId}/information/useIdeItem`, 'theia')
                }
            },
            openIdeAccept(){
                var me = this
                me.openIde = true
            },
            logoutToGit(){
                var me = this
                localStorage.removeItem("gitOrgName");
                localStorage.removeItem("gitUserName");
                localStorage.removeItem("gitToken");
                localStorage.removeItem("loginType");

                me.isGitLogin = false
                me.gitOrgName = null
                me.gitUserName = null
                me.gitToken = null
                me.gitPicture = null 
            },
            async startGitFork(){
                var me = this 
                me.isPushing = true
                try {
                    if(me.projectId){
                        me.setString(`db://definitions/${me.projectId}/information/gitOrgName`, me.gitOrgName)
                        me.setString(`db://definitions/${me.projectId}/information/gitRepoName`, me.gitRepoName)
                    }
                    let forkData
                    if(me.gitOrgName != me.gitUserName){
                        forkData = {
                            organization: me.gitOrgName,
                            name: me.gitRepoName
                        };
                    } else {
                        forkData = {
                            name: me.gitRepoName
                        };
                    }
    
                    let forkRes = await axios.post(`https://api.github.com/repos/${me.gitForkOrgName}/${me.gitForkRepoName}/forks`, forkData, { headers: me.gitHeaders })
                    .catch(async function (error) {
                        if(error.response && error.response.data && error.response.data.message){
                            var errText = error.response.data.message
                            if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                errText = errText + ', ' + error.response.data.errors[0].message
                                if(errText.includes("Bad credentials")){
                                    errText = errText + "[ Please, Check your Access token ]"
                                }
                            }
                            me.showErrSnackBar(errText)
                        } else {
                            me.showErrSnackBar(error.message)
                        }
                    }); 
                    console.log(forkRes)
                    if(forkRes){
                        me.setString(`db://definitions/${me.projectId}/information/firstCommit`, "false")
                        me.isFirstCommit = false
                        me.gitTabKey++;
                        me.gitTab = 2
                        me.gitCommitMessage = null
                        me.isPushing = false
                        if(me.repoList.find(repoName => repoName == forkRes.data.name)){
                            me.gitSnackBar.show = true
                            me.gitSnackBar.timeout = -1
                            me.gitSnackBar.Text = "Forked repository already exists."
                            me.gitSnackBar.Color = "warning"
                            me.gitSnackBar.icon="warning"
                            me.gitSnackBar.title="Warning"
                            me.gitRepoName = forkRes.data.name

                            if(me.projectId){
                                me.setString(`db://definitions/${me.projectId}/information/gitRepoName`, me.gitRepoName)
                            }
                        } else {
                            me.gitSnackBar.show = true
                            me.gitSnackBar.timeout = 3000
                            me.gitSnackBar.Text = "Fork 완료되었습니다."
                            me.gitSnackBar.Color = "success"
                            me.gitSnackBar.icon="check_circle"
                            me.gitSnackBar.title="Success"
                        }
                    }
                } catch(e) {
                    me.showErrSnackBar(e.message)
                }
            },
            async startGitCommit(){
                var me = this
                me.gitTreeList = []
                me.commitStepText = 'Started Commit'
                if(me.projectId){
                    me.setString(`db://definitions/${me.projectId}/information/gitOrgName`, me.gitOrgName)
                    me.setString(`db://definitions/${me.projectId}/information/gitRepoName`, me.gitRepoName)
                }
                me.isPushing = true
                me.firstCommit = false

                me.pushTree = []
                me.removeTree = []
                
                me.getRoofCnt = 0
                me.commitStepText = 'Check Git Repo'
                let gitRepoInfo = await axios.get(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/trees/template`, { headers: me.gitHeaders })
                .catch(async function (error) {
                    if (error.response) {
                        if(error.response.data.message == "Not Found" && error.response.status == 404){
                            me.isFirstCommit = true
                            me.commitStepText = 'Create New Repo'
                            me.firstCommit = true
                            let newRepoData = {
                                name: me.gitRepoName,
                                auto_init: true
                            }
                            var createRepoUrl
                            if(me.gitOrgName == me.gitUserName){
                                createRepoUrl = `https://api.github.com/user/repos`
                            } else {
                                createRepoUrl = `https://api.github.com/orgs/${me.gitOrgName}/repos`
                            }
                            let addNewRepo = await axios.post(createRepoUrl, newRepoData, { headers: me.gitHeaders })
                            .catch(async function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            console.log(addNewRepo)
                            if(addNewRepo){
                                var blob = {
                                    path: "README.md"
                                }
                                me.gitTreeList.push(blob)
                                setTimeout(function () {
                                    me.setPushTree()
                                }, 5000)
                            }
                        } else {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }
                    }
                }); 
                if(!me.firstCommit && gitRepoInfo){
                    me.commitStepText = 'Get Git Repo'
                    me.treesha = gitRepoInfo.data.sha
                    if(gitRepoInfo.data.tree){
                        gitRepoInfo.data.tree.forEach(function (element) {
                            if(element.type == 'blob'){
                                me.gitTreeList.push(element)
                            } else if(element.type == 'tree'){
                                me.getMoreTreeList(element)
                            }
                        })
                    }
                }
            },
            async getMoreTreeList(element) {
                var me = this 
                me.getRoofCnt++;
                try {
                    let gitData = await axios.get(element.url, { headers: me.gitHeaders })
                    .catch(function (error) {
                        if(error.response && error.response.data && error.response.data.message){
                            var errText = error.response.data.message
                            if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                errText = errText + ', ' + error.response.data.errors[0].message
                            }
                            me.showErrSnackBar(errText)
                        } else {
                            me.showErrSnackBar(error.message)
                        }
                    }); 
                    me.getRoofCnt--;
                    gitData.data.tree.forEach(function (elem) {
                        elem.path = element.path + "/" + elem.path
                        if(elem.type == 'blob'){
                            me.gitTreeList.push(elem)
                        } else if(element.type == 'tree'){
                            me.getMoreTreeList(elem)
                        }
                    })
                    if(me.getRoofCnt == 0){
                        me.setPushTree()
                    }
                } catch(error) {
                    if(error.response && error.response.data && error.response.data.message){
                        var errText = error.response.data.message
                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                            errText = errText + ', ' + error.response.data.errors[0].message
                        }
                        me.showErrSnackBar(errText)
                    } else {
                        me.showErrSnackBar(error.message)
                    }
                }
            },
            async setPushTree(){
                var me = this
                me.commitStepText = 'Set Git Commit Tree'
                try {
                    var isChanged = false
                    me.removeTree = []
                    me.gitTreeList.forEach(function (elData) {
                        if(!me.fullPathList.find(element => element.fullPath == elData.path)){
                            if(elData.path == ".gitpod.yml" || elData.path == "init.sh"){
                                console.log(elData.path)
                            } else {
                                isChanged = true
                                let pushData = {
                                    path: elData.path, 
                                    mode:"100644",
                                    type:"blob",
                                    sha: null
                                }
        
                                me.removeTree.push(pushData)
                            }
                        } 
                    })
    
                    var pushTreeCnt = 0
                    var allCnt = 0
                    me.fullPathList.forEach(async function (elData) {
                        if(!me.gitTreeList.find(element => element.path == elData.fullPath) || ((me.copyChangedPathLists && me.copyChangedPathLists.find(element => element.replace("for-model/","") == elData.fullPath)) || me.pushType != "Push")){
                            isChanged = true
                            var code
                            if(elData.key){
                                Object.keys(me.mergeCodeList).some(function (key) {
                                    if(key == elData.fullPath){
                                        code = me.mergeCodeList[key].code
                                        return true;
                                    }
                                })
                                if(!code){
                                    var fileCode = me.getCodeList.find(getCodeElement => getCodeElement.key == elData.key)
                                    if(fileCode && fileCode.code){
                                        code = fileCode.code
                                    }
                                }
                            } else if(elData.code){
                                code = elData.code
                            }

                            if(!code){
                                code = 'undefined'
                            }

                            let data = {
                                content: code,
                                encoding: 'utf-8',
                            };
                            pushTreeCnt++;
                            let res = await axios.post(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/blobs`, data, { headers: me.gitHeaders })
                            .catch(function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            if(res){
                                let pushData = {
                                    path: elData.fullPath, 
                                    mode:"100644",
                                    type:"blob",
                                    sha: res.data.sha
                                }
                                me.pushTree.push(pushData)
                                pushTreeCnt--;
                            }
    
                            if(pushTreeCnt == 0){
                                if(me.isFirstCommit){
                                    await me.addInitShell()
                                    await me.addGitPodYaml()
                                }
                                var allTreeList = me.removeTree.concat(me.pushTree)
                                me.commitToGit(allTreeList)
                            }
                        }
                        allCnt++; 
                        if(me.fullPathList.length == allCnt && !isChanged){
                            me.isPushing = false
                            me.commitStepText = null
                            me.gitSnackBar.show = true
                            me.gitSnackBar.timeout = -1
                            me.gitSnackBar.Text = "Nothing changed"
                            me.gitSnackBar.Color = "warning"
                            me.gitSnackBar.icon="warning"
                            me.gitSnackBar.title="Warning"
                        }
                        
                    })
                } catch(error) {
                    if(error.response && error.response.data && error.response.data.message){
                        var errText = error.response.data.message
                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                            errText = errText + ', ' + error.response.data.errors[0].message
                        }
                        me.showErrSnackBar(errText)
                    } else {
                        me.showErrSnackBar(error.message)
                    }
                }
            },
            async forcePush(){
                var me = this
                me.gitSnackBar.show = false
                me.isPushing = true
                me.gitTreeList = []
                me.commitStepText = 'Set Git Commit Tree'
                var forcePushTree = []
                try {
                    var pushTreeCnt = 0
                    me.fullPathList.forEach(async function (elData) {
                        var code
                        if(elData.key){
                            Object.keys(me.mergeCodeList).some(function (key) {
                                if(key == elData.fullPath){
                                    code = me.mergeCodeList[key].code
                                    return true;
                                }
                            })
                            if(!code){
                                var fileCode = me.getCodeList.find(getCodeElement => getCodeElement.key == elData.key)
                                if(fileCode && fileCode.code){
                                    code = fileCode.code
                                }
                            }
                        } else if(elData.code){
                            code = elData.code
                        }

                        if(!code){
                            code = 'undefined'
                        }
                        let data = {
                            content: code,
                            encoding: 'utf-8',
                        };
                        pushTreeCnt++;
                        let resforce = await axios.post(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/blobs`, data, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        let pushData = {
                            path: elData.fullPath, 
                            mode:"100644",
                            type:"blob",
                            sha: resforce.data.sha
                        }
                        forcePushTree.push(pushData)
                        pushTreeCnt--;

                        if(pushTreeCnt == 0){
                            me.commitToGit(forcePushTree)
                        }
                    })
                } catch(error) {
                    if(error.response && error.response.data && error.response.data.message){
                        var errText = error.response.data.message
                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                            errText = errText + ', ' + error.response.data.errors[0].message
                        }
                        me.showErrSnackBar(errText)
                    } else {
                        me.showErrSnackBar(error.message)
                    }
                }
            },
            async commitToGit(treeList){
                var me = this 
                try {
                    if(me.firstCommit){
                        let getRepo = await axios.get(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/trees/main`, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        console.log(getRepo)
                        me.treesha = getRepo.data.sha
                    }
                    if(me.treesha){
                        me.commitStepText = 'Commit to Git'
                        let postTreeData = {
                            tree: treeList,
                            base_tree: me.treesha
                        }
                        let postTreeResult = await axios.post(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/trees`, postTreeData, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        console.log(postTreeResult)
                        me.treesha = postTreeResult.data.sha
                        
                        if(!me.parentsCommitSha && !me.firstCommit) {
                            // let commitRes = await axios.get(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/commits/main`, null, { headers: me.gitHeaders })
                            let commitRes = await axios.get(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/commits/template`, { headers: me.gitHeaders })
                            .catch(function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            console.log(commitRes)
                            me.parentsCommitSha = commitRes.data.sha
                        }
                        let postCommitData = {}
                        var commitMsg
                        if(me.gitCommitMessage){
                            commitMsg = me.gitCommitMessage
                        } else {
                            commitMsg = "commit"
                        }
                        if(me.firstCommit) {
                            postCommitData = {
                                tree: postTreeResult.data.sha,
                                message: commitMsg
                            }
                        } else {
                            postCommitData = {
                                tree: postTreeResult.data.sha,
                                message: commitMsg,
                                parents: [
                                    me.parentsCommitSha   
                                ]
                            }
                        }
                        let postCommitResult = await axios.post(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/commits`, postCommitData, { headers: me.gitHeaders })
                        .catch(function (error) {
                            if(error.response && error.response.data && error.response.data.message){
                                var errText = error.response.data.message
                                if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                    errText = errText + ', ' + error.response.data.errors[0].message
                                }
                                me.showErrSnackBar(errText)
                            } else {
                                me.showErrSnackBar(error.message)
                            }
                        }); 
                        console.log(postCommitResult)
                        me.parentsCommitSha = postCommitResult.data.sha
        
                        let patchData = {
                            sha: postCommitResult.data.sha,
                            force: true
                        }

                        me.commitStepText = 'Push to Git'
                        if(me.firstCommit){
                            let patchMainResult = await axios.patch(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/refs/heads/main`, patchData, { headers: me.gitHeaders })
                            .catch(function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            console.log(patchMainResult)
                            let templateBranchData = {
                                ref: "refs/heads/template",
                                sha: patchMainResult.data.object.sha
                            }
                            let createBranchResult = await axios.post(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/refs`, templateBranchData, { headers: me.gitHeaders })
                            .catch(function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            console.log(createBranchResult)
                        } else {
                            let patchTemplateResult = await axios.patch(`https://api.github.com/repos/${me.gitOrgName}/${me.gitRepoName}/git/refs/heads/template`, patchData, { headers: me.gitHeaders })
                            .catch(function (error) {
                                if(error.response && error.response.data && error.response.data.message){
                                    var errText = error.response.data.message
                                    if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                                        errText = errText + ', ' + error.response.data.errors[0].message
                                    }
                                    me.showErrSnackBar(errText)
                                } else {
                                    me.showErrSnackBar(error.message)
                                }
                            }); 
                            console.log(patchTemplateResult)
                        }
                        var firstPush = false
                        if(me.isFirstCommit){
                            firstPush = true
                        } 

                        me.commitStepText = null
                        me.isPushing = false
                        me.setString(`db://definitions/${me.projectId}/information/firstCommit`, "false")
                        me.isFirstCommit = false
                        if(firstPush){
                            me.gitTabKey++;
                        }
                        me.gitTab = 2
                        me.gitCommitMessage = null
                        me.copyChangedPathLists = []
                        me.gitSnackBar.show = true
                        me.gitSnackBar.timeout = 3000
                        me.gitSnackBar.Text = "Commit/Push 완료되었습니다."
                        me.gitSnackBar.Color = "success"
                        me.gitSnackBar.icon="check_circle"
                        me.gitSnackBar.title="Success"
                        
                    }

                } catch(error) {
                    if(error.response && error.response.data && error.response.data.message){
                        var errText = error.response.data.message
                        if(error.response.data.errors && error.response.data.errors[0] && error.response.data.errors[0].message){
                            errText = errText + ', ' + error.response.data.errors[0].message
                        }
                        me.showErrSnackBar(errText)
                    } else {
                        me.showErrSnackBar(error.message)
                    }
                }
            }
        }
    }
</script>


<style scoped>

</style>